import '../paper-header/paper-header.js';
import '@polymer/iron-icons/hardware-icons.js';
import '@polymer/paper-item/paper-item.js';
import '../katapult-elements/katapult-button.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
import { PolymerElement } from '@polymer/polymer/polymer-element.js';
import { SquashNulls } from '../../modules/SquashNulls.js';
import { ToArray } from '../../modules/ToArray.js';

class PoleAppPortalCompanyOptions extends PolymerElement {
  static get template() {
    return html`
      <style include="paper-dialog-style">
        [hidden] {
          display: none !important;
        }
        .companyRow {
          display: flex;
          flex-direction: row;
          align-items: center;
          padding: 8px;
          padding-left: 16px;
          font-size: 11pt;
          color: var(--primary-text-color);
          white-space: nowrap;
        }
        .companyRow > span {
          flex-grow: 1;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .companyRow > span[pending] {
          font-style: italic;
          color: var(--primary-text-color-faded);
        }
        .companyRow katapult-button {
          padding: 0 8px 0 8px;
        }
        .companyRow katapult-button[iconOnly] {
          border-radius: 0;
        }
        .companyRow .buttons {
          display: flex;
          flex-direction: row;
          gap: 8px;
        }
        katapult-button:not([iconOnly]) {
          min-width: 75px;
        }
        #requestNewCompanyDropdown {
          padding: 0 16px 8px 16px;
        }
        paper-dialog {
          max-width: 800px;
          min-width: 400px;
        }
      </style>
      <katapult-firebase-worker path="utility_info/[[utilityCompany]]/attachers" data="{{attachers}}"></katapult-firebase-worker>
      <katapult-firebase-worker
        path="photoheight/company_space/[[companyId]]/attacher_list"
        data="{{attacherList}}"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        path="photoheight/company_space/[[companyId]]/companies_who_can_submit_for_me"
        data="{{companiesWhoCanSubmitForMe}}"
      ></katapult-firebase-worker>
      <katapult-firebase-worker
        path="photoheight/company_space/[[companyId]]/contact_info/mr_notification"
        data="{{mrNotificationContact}}"
      ></katapult-firebase-worker>
      <paper-dialog id="cancelSubmissionRequestDialog" entry-animation="scale-up-animation" exit-animation="fade-out-animation">
        <div title="" amber="">Cancel Submission Request</div>
        <div body="">
          Are you sure that you want to cancel [[possessive]] request to submit for <b>[[cancelSubmissionRequestTarget.name]]</b>?
        </div>
        <div buttons="">
          <katapult-button color="var(--paper-grey-500)" dialog-dismiss>Cancel</katapult-button>
          <katapult-button color="var(--paper-amber-500)" loading="[[cancelingRequest]]" on-click="confirmCancelSubmissionRequest"
            >Confirm</katapult-button
          >
        </div>
      </paper-dialog>
      <paper-dialog id="revokePermissionDialog" entry-animation="scale-up-animation" exit-animation="fade-out-animation">
        <div title="" amber="">Revoke Submission Permission</div>
        <div body="">
          Are you sure that you want to revoke permission for <b>[[revokePermissionTarget.name]]</b> to submit on [[possessive]] behalf?
        </div>
        <div buttons="">
          <katapult-button color="var(--paper-grey-500)" dialog-dismiss>Cancel</katapult-button>
          <katapult-button color="var(--paper-amber-500)" loading="[[revokingPermission]]" on-click="confirmRevokePermission"
            >Confirm</katapult-button
          >
        </div>
      </paper-dialog>
      <paper-dialog id="removeYourPermissionDialog" entry-animation="scale-up-animation" exit-animation="fade-out-animation">
        <div title="" amber="">Remove Submission Permission</div>
        <div body="">
          Are you sure that you want to remove [[possessive]] permission to submit on behalf of <b>[[removeYourPermissionTarget.name]]</b>?
        </div>
        <div buttons="">
          <katapult-button color="var(--paper-grey-500)" dialog-dismiss>Cancel</katapult-button>
          <katapult-button color="var(--paper-amber-500)" loading="[[removingYourPermission]]" on-click="confirmRemoveYourPermission"
            >Confirm</katapult-button
          >
        </div>
      </paper-dialog>
      <paper-dialog id="approveSubmissionDialog" entry-animation="scale-up-animation" exit-animation="fade-out-animation">
        <div title="" secondary-color="">Approve Submission Request</div>
        <template is="dom-if" if="[[!approvingFromRequestor]]">
          <div body="">
            Are you sure that you want to grant permission for <b>[[approveSubmissionTarget.name]]</b> to submit on [[possessive]] behalf?
          </div>
        </template>
        <template is="dom-if" if="[[approvingFromRequestor]]">
          <div body="">
            Are you sure that you want to grant permission for [[companyName]] to submit on
            <b>[[approveSubmissionTarget.name]]'s</b> behalf?
          </div>
        </template>
        <div buttons="">
          <katapult-button color="var(--paper-grey-500)" dialog-dismiss>Cancel</katapult-button>
          <katapult-button color="var(--secondary-color)" loading="[[approvingRequest]]" on-click="confirmApproveSubmissionRequest"
            >Approve</katapult-button
          >
        </div>
      </paper-dialog>
      <paper-dialog id="denySubmissionDialog" entry-animation="scale-up-animation" exit-animation="fade-out-animation">
        <div title="" secondary-color="">Deny Submission Request</div>
        <div body="">
          Are you sure that you want to deny permission for <b>[[denySubmissionTarget.name]]</b> to submit on [[possessive]] behalf?
        </div>
        <div buttons="">
          <katapult-button color="var(--paper-grey-500)" dialog-dismiss>Cancel</katapult-button>
          <katapult-button color="var(--secondary-color)" loading="[[denyingSubmission]]" on-click="confirmDenySubmissionRequest"
            >Deny</katapult-button
          >
        </div>
      </paper-dialog>
      <paper-dialog id="requestPermissionDialog" entry-animation="scale-up-animation" exit-animation="fade-out-animation">
        <div title="" secondary-color="">Request Permission to Submit</div>
        <div body="">
          <span>Are you sure that you want to request permission</span>
          <template is="dom-if" if="[[!equal(companyId, userGroup)]]">
            <span> for <b>[[companyName]]</b></span>
          </template>
          <span> to submit on behalf of <b>[[requestPermissionTarget.name]]</b>?</span>
        </div>
        <div buttons="">
          <katapult-button color="var(--paper-grey-500)" dialog-dismiss>Cancel</katapult-button>
          <katapult-button color="var(--secondary-color)" loading="[[requestingPermission]]" on-click="confirmRequestPermission"
            >Request</katapult-button
          >
        </div>
      </paper-dialog>
      <paper-dialog id="addAttacherDialog" entry-animation="scale-up-animation" exit-animation="fade-out-animation">
        <div title="" secondary-color="">Add New Attacher</div>
        <div body="">
          <p>
            Please make sure your company is not in the drop-down list of existing companies. One company submitting under two slightly
            different names could create more paperwork for you and cause a lot of confusion.
          </p>
          <p>
            All companies with existing agreements with [[config.firebaseData.name]] are in the list. In order to be approved to attach to
            poles, you will need to contact [[config.firebaseData.name]] and setup an Attacher Agreement
          </p>
          <paper-input id="addAttacherNameInput" label="New Company Name" value="{{addAttacherName}}"></paper-input>
        </div>
        <div buttons="">
          <katapult-button color="var(--paper-grey-500)" dialog-dismiss>Cancel</katapult-button>
          <katapult-button class="confirm" on-click="confirmAddAttacher" color="var(--secondary-color)">Add Company</katapult-button>
        </div>
      </paper-dialog>
      <template is="dom-if" if="[[showSubmissionOptions]]">
        <paper-header-content opened>
          <paper-cell slot="header" style="cursor: pointer;">Companies I Can Submit For</paper-cell>
          <template is="dom-repeat" items="[[sortedAttacherList]]">
            <div class="companyRow" slot="content">
              <span pending$="[[item.pending]]">[[item.name]]</span>
              <div class="buttons">
                <template is="dom-if" if="[[item.pending]]">
                  <template is="dom-if" if="[[systemAdmin]]">
                    <katapult-button size="small" color="var(--paper-green-500)" on-click="promptApproveRequest">Approve</katapult-button>
                  </template>
                  <katapult-button size="small" color="var(--paper-grey-500)" on-click="promptCancelSubmissionRequest"
                    >Cancel Request</katapult-button
                  >
                </template>
                <template is="dom-if" if="[[!item.pending]]">
                  <katapult-button
                    icon="clear"
                    size="20"
                    iconOnly
                    noBorder
                    noBackground
                    on-click="promptRemoveYourPermission"
                  ></katapult-button>
                </template>
              </div>
            </div>
          </template>
          <katapult-drop-down
            id="requestNewCompanyDropdown"
            slot="content"
            items="[[attachers]]"
            label="Request To Submit For New Company"
            label-function="[[boundCompanyNameLabelFunction]]"
            value-path="$key"
            no-label-float
            on-value-changed="requestNewCompanyValueChanged"
          >
            <paper-item name="attacher" on-click="promptAddNewCompany">My Company Is Not Listed...</paper-item>
          </katapult-drop-down>
        </paper-header-content>
        <paper-header-content opened>
          <paper-cell slot="header" style="cursor: pointer;">Companies Who Can Submit For Me</paper-cell>
          <template is="dom-repeat" items="[[sortedFilteredCompaniesWhoCanSubmitForMe]]">
            <div class="companyRow" slot="content">
              <span pending$="[[item.pending]]">[[item.name]]</span>
              <div class="buttons">
                <template is="dom-if" if="[[item.pending]]">
                  <katapult-button size="small" color="var(--paper-green-500)" on-click="promptApprovePermission">Approve</katapult-button>
                  <katapult-button size="small" color="var(--paper-red-500)" on-click="promptDenyPermission">Deny</katapult-button>
                </template>
                <template is="dom-if" if="[[!item.pending]]">
                  <katapult-button size="small" color="var(--paper-grey-500)" on-click="promptRevokePermission"
                    >Revoke Permission</katapult-button
                  >
                </template>
              </div>
            </div>
          </template>
        </paper-header-content>
      </template>
      <paper-header-content opened hidden$="[[!showMrNotificationInfo]]">
        <paper-cell slot="header" style="cursor: pointer;">Company Contact For MR Notification</paper-cell>
        <div slot="content" style="padding:0 16px;">
          <paper-input id="mrNotificationEmail" label="Email" value="{{mrNotificationContact.email}}"></paper-input>
          <paper-input id="mrNotificationName" label="Name" value="{{mrNotificationContact.name}}"></paper-input>
          <paper-input id="mrNotificationPhone" label="Phone" value="{{mrNotificationContact.phone}}"></paper-input>
          <paper-input id="mrNotificationAddr1" label="Address Line 1" value="{{mrNotificationContact.address_line_1}}"></paper-input>
          <paper-input id="mrNotificationAddr2" label="Address Line 2" value="{{mrNotificationContact.address_line_2}}"></paper-input>
          <paper-input id="mrNotificationCity" label="City" value="{{mrNotificationContact.city}}"></paper-input>
          <div style="display:flex;">
            <paper-input
              id="mrNotificationState"
              style="margin-right:10px;"
              label="State"
              value="{{mrNotificationContact.state}}"
            ></paper-input>
            <paper-input id="mrNotificationZip" label="Zip" value="{{mrNotificationContact.zip}}"></paper-input>
          </div>
          <div style="display:flex; justify-content:end; margin: 2px 0 10px;">
            <katapult-button color="var(--secondary-color)" on-click="saveMrNotificationContact">Save</katapult-button>
          </div>
        </div>
      </paper-header-content>
      <!-- Attacher Agreement -->
      <paper-header-content>
        <paper-cell slot="header" style="cursor: pointer; gap: var(--sl-spacing-x-small);">
          <material-icon icon="balance"></material-icon>
          <span>Agreement</span>
        </paper-cell>
        <div slot="content" style="margin-left:10px; margin-right:10px">
          <file-input
            path="photoheight/company_space/[[utilityCompany]]/agreements/[[companyId]]"
            storage-path="pole_application_agreements/[[companyId]]"
            label="Attacher Agreement"
            read-only="[[!isPortalAdmin]]"
            multiple
          ></file-input>
        </div>
      </paper-header-content>
    `;
  }

  static get is() {
    return 'pole-app-portal-company-options';
  }
  static get properties() {
    return {
      companyId: String,
      companyName: String,
      systemAdmin: Boolean,
      userGroup: String,
      possessive: {
        type: String,
        computed: 'getPossessive(companyId, userGroup, companyName)'
      },
      mrNotificationContact: {
        type: Object,
        value: () => ({})
      },
      showSubmissionOptions: {
        type: Boolean,
        value: true
      },
      showMrNotificationInfo: {
        type: Boolean,
        value: true
      }
    };
  }
  static get observers() {
    return [
      'calcSortedFilteredCompaniesWhoCanSubmitForMe(companiesWhoCanSubmitForMe.*, systemAdmin, companyId)',
      'calcSortedAttacherList(attacherList.*)'
    ];
  }
  ready() {
    super.ready();
    this.boundCompanyNameLabelFunction = this.companyNameLabelFunction.bind(this);
  }
  or(a, b) {
    return a || b;
  }
  equal(a, b) {
    return a == b;
  }
  companyNameLabelFunction(item) {
    if (item) {
      let label = item.name;
      if (window.config.firebaseData.utilityCompany == 'ppl_attachments') {
        let agreementNumber = SquashNulls(this.attachers, item.$key, 'agreement_number') || '(No Agreement)';
        label = agreementNumber + ' - ' + label;
      }
      return label;
    }
  }
  calcSortedAttacherList() {
    this.sortedAttacherList = ToArray(this.attacherList)
      .map((x) => {
        x.name = this.companyNameLabelFunction(x);
        return x;
      })
      .sort((a, b) => {
        if (a.pending && !b.pending) return -1;
        if (b.pending && !a.pending) return 1;
        return (a.name || '').localeCompare(b.name);
      });
  }
  calcSortedFilteredCompaniesWhoCanSubmitForMe() {
    this.sortedFilteredCompaniesWhoCanSubmitForMe = ToArray(this.companiesWhoCanSubmitForMe)
      .map((x) => {
        x.name = this.companyNameLabelFunction(x);
        return x;
      })
      .sort((a, b) => {
        if (a.pending && !b.pending) return -1;
        if (b.pending && !a.pending) return 1;
        return (a.name || '').localeCompare(b.name);
      })
      .filter((company) => {
        return company.$key != this.companyId || this.systemAdmin;
      });
  }
  confirmAddAttacher() {
    this.$.addAttacherNameInput.invalid = false;
    let sanitizedAddAttacherName = (this.addAttacherName || '').trim();
    if (!sanitizedAddAttacherName) {
      this.$.addAttacherNameInput.errorMessage = 'New Attacher Name is required';
      this.$.addAttacherNameInput.invalid = true;
    } else {
      this.$.addAttacherNameInput.value = '';
      this.$.addAttacherDialog.close();
      this.requestPermissionTargetId = sanitizedAddAttacherName;
      this.requestPermissionTarget = { name: sanitizedAddAttacherName, addAttacher: true };
      this.$.requestPermissionDialog.open();
    }
  }
  async confirmApproveSubmissionRequest() {
    if (this.approveSubmissionTarget) {
      this.approvingRequest = true;
      await firebase.functions().httpsCallable('takeSystemAction')({ actionId: this.approveSubmissionTarget.actionId, action: 'approve' });
      this.approvingRequest = false;
      this.$.approveSubmissionDialog.close();
      this.approveSubmissionTarget = null;
    } else throw 'Missing Approve Submission Target';
  }
  async confirmCancelSubmissionRequest() {
    if (this.cancelSubmissionRequestTarget) {
      this.cancelingRequest = true;
      await firebase.functions().httpsCallable('takeSystemAction')({
        actionId: this.cancelSubmissionRequestTarget.actionId,
        action: 'cancel'
      });
      this.cancelingRequest = false;
      this.$.cancelSubmissionRequestDialog.close();
      this.cancelSubmissionRequestTarget = null;
    } else throw 'Missing Cancel Submission Target';
  }
  async confirmDenySubmissionRequest() {
    if (this.denySubmissionTarget) {
      this.denyingSubmission = true;
      await firebase.functions().httpsCallable('takeSystemAction')({ actionId: this.denySubmissionTarget.actionId, action: 'deny' });
      this.denyingSubmission = false;
      this.$.denySubmissionDialog.close();
      this.denySubmissionTarget = null;
    } else throw 'Missing Deny Submission Target';
  }
  async confirmRequestPermission() {
    if (this.requestPermissionTargetId && this.requestPermissionTarget) {
      this.requestingPermission = true;
      let request = {
        companyId: this.companyId,
        attacher: this.requestPermissionTargetId,
        add_attacher: this.requestPermissionTarget.addAttacher || false
      };
      await firebase.functions().httpsCallable('requestSubmitFor')(request);
      this.requestingPermission = false;
      this.$.requestPermissionDialog.close();
      this.requestPermissionTargetId = this.requestPermissionTarget = null;
    } else throw 'Missing Request Permission Target';
  }
  async confirmRemoveYourPermission() {
    if (this.removeYourPermissionTarget) {
      this.removingYourPermission = true;
      await firebase.functions().httpsCallable('poleAppRevokeSubmissionPermission')({
        attacherId: this.removeYourPermissionTarget.$key,
        companyId: this.companyId
      });
      this.removingYourPermission = false;
      this.$.removeYourPermissionDialog.close();
      this.removeYourPermissionTarget = null;
    } else throw 'Missing Remove Your Permission Target';
  }
  async confirmRevokePermission() {
    if (this.revokePermissionTarget) {
      this.revokingPermission = true;
      await firebase.functions().httpsCallable('poleAppRevokeSubmissionPermission')({
        attacherId: this.companyId,
        companyId: this.revokePermissionTarget.$key
      });
      this.revokingPermission = false;
      this.$.revokePermissionDialog.close();
      this.revokePermissionTarget = null;
    } else throw 'Missing Revoke Permission Target';
  }
  getPossessive(companyId, userGroup, companyName) {
    return companyId == userGroup ? 'your' : companyName + "'s";
  }
  promptAddNewCompany(e) {
    if (e && e.currentTarget && e.currentTarget.parentElement) e.currentTarget.parentElement.close();
    this.$.addAttacherDialog.open();
  }
  promptApprovePermission(e) {
    this.approveSubmissionTarget = e.model.item;
    this.approvingFromRequestor = false;
    this.$.approveSubmissionDialog.open();
  }
  promptApproveRequest(e) {
    this.approveSubmissionTarget = e.model.item;
    this.approvingFromRequestor = true;
    this.$.approveSubmissionDialog.open();
  }
  promptCancelSubmissionRequest(e) {
    this.cancelSubmissionRequestTarget = e.model.item;
    this.$.cancelSubmissionRequestDialog.open();
  }
  promptDenyPermission(e) {
    this.denySubmissionTarget = e.model.item;
    this.$.denySubmissionDialog.open();
  }
  promptRemoveYourPermission(e) {
    this.removeYourPermissionTarget = e.model.item;
    this.$.removeYourPermissionDialog.open();
  }
  promptRevokePermission(e) {
    this.revokePermissionTarget = e.model.item;
    this.$.revokePermissionDialog.open();
  }
  requestNewCompanyValueChanged(e) {
    e.currentTarget.value = null;
    if (e.detail.value) {
      this.requestPermissionTargetId = e.detail.value;
      this.requestPermissionTarget = this.get(`attachers.${this.requestPermissionTargetId}`);
      this.$.requestPermissionDialog.open();
    }
  }
  async saveMrNotificationContact() {
    await FirebaseWorker.ref(`photoheight/company_space/${this.companyId}/contact_info/mr_notification`).set({
      name: this.$.mrNotificationName.value,
      phone: this.$.mrNotificationPhone.value,
      email: this.$.mrNotificationEmail.value,
      address_line_1: this.$.mrNotificationAddr1.value,
      address_line_2: this.$.mrNotificationAddr2.value,
      city: this.$.mrNotificationCity.value,
      state: this.$.mrNotificationState.value,
      zip: this.$.mrNotificationZip.value
    });
  }
}
window.customElements.define(PoleAppPortalCompanyOptions.is, PoleAppPortalCompanyOptions);
